import { gql } from '@apollo/client';

export const GET_EXTERNAL_WORK_BY_ID = gql`
  query GetExternalWork($id: ID!) {
    externalWork(id: $id) {
      id
      # workName
      operatorsNumber
      externalCompanyIDs
    }
  }
`;

// Warm-up batch para los selectors de tabla. MISMOS campos que
// GET_EXTERNAL_WORK_BY_ID: un campo de diferencia = cache miss per-row.
export const EXTERNAL_WORKS_BY_IDS_WARMUP = gql`
  query ExternalWorksByIds($ids: [ID!]!) {
    externalWorksByIds(ids: $ids) {
      id
      operatorsNumber
      externalCompanyIDs
    }
  }
`;
